// If none of the translations has loaded before this is executed
// initialise
window.translations ??= {}

// Translation mode: the page renders [data-translation-mode-keys] and every t() key is recorded
const translationModeEnabled = () => !!document.querySelector('[data-translation-mode-keys]');

var I18n = {
  available_locales: JSON.parse(document.body.getAttribute('data-locales')),
  keys: window.translations,
  usedKeys: translationModeEnabled() ? new Set() : null,
  overrides: JSON.parse(document.getElementById("i18n-overrides")?.textContent || '{}'),
    
  t: function(k, params) {
    var p = params || {};
    var translation = undefined;
    var locale = p.locale || window.I18n.locale;

    // Fall back to default translations
    var keyList = window.I18n.keys || window.translations || {};
    var keys = keyList[locale] || {};
    var overrides = window.I18n.overrides[locale] || {};

    if (p.scope) {
      translation = (overrides[p.scope] || {})[k]
      translation ||= ((keys[p.scope] || {})[k] || '')
      
    } else if (typeof keys[k] == 'object') {
      if (I18n.fallbacks[0] != locale) {
        // Get translations from fallback locale and merge translations from this locale, so they take precedence.
        // This is done in case this locale has missing translations.
        return Object.assign(I18n.t(k, Object.assign(p, { locale: I18n.fallbacks[0] })), keys[k]);
      } else {
        return keys[k];
      }
    } else {
      translation = overrides[k]
      translation ||= (keys[k] || '')
    }

    if (typeof translation == 'string') {
      translation = translation.slice(0); // clone
    }


    if (translation.length == 0) {
      // Fallback if this locale is not the fallback locale
      if (I18n.fallbacks[0] != locale) {
        return I18n.t(k, Object.assign(p, { locale: I18n.fallbacks[0] }))
      }
      return k;
    }

    for (var paramKey in p) {
      if (paramKey != 'scope' && paramKey != 'locale') {
        translation = translation.replace(new RegExp('%{' + paramKey + '}', 'ig'), p[paramKey]);
      }
    }
    if (I18n.usedKeys) {
      I18n.usedKeys.add(p.scope ? `${p.scope}.${k}` : k);
    }
    return translation;
  },
  locale: document.body.getAttribute('data-locale'),
  fallbacks: JSON.parse(document.body.getAttribute('data-default-locale')),
  exists: function(k) {
    return I18n.keys[I18n.locale].hasOwnProperty(k) || I18n.keys[I18n.fallbacks[0]].hasOwnProperty(k);
  },
  reload: function(){
    this.available_locales = JSON.parse(document.body.getAttribute('data-locales'));
    this.locale = document.body.getAttribute('data-locale');
    this.fallbacks = JSON.parse(document.body.getAttribute('data-default-locale'));
  }
}

document.addEventListener('turbo:load', () => {
  if (window.I18n?.reload) {
    window.I18n.reload();
  }
})

// Start a fresh key recording before the new page renders (components may call t() before turbo:load)
document.addEventListener('turbo:before-render', (event) => {
  const enabled = !!event.detail.newBody?.querySelector('[data-translation-mode-keys]');
  I18n.usedKeys = enabled ? new Set() : null;
})

window.I18n = I18n
